/* eslint no-new: 0 */
/* eslint no-undef: 0 */
/* eslint no-unused-vars: 0 */

import 'babel-polyfill';
import Vue from 'vue';

import { directive as onClickaway } from 'vue-clickaway';
import VueScrollTo from 'vue-scrollto';
import router from '@/shared/routes';
import bootstrapVue from '@/shared/bootstrap_vue';
import store from './show/store';
import vueResource from './show/resources';
import App from './show/components/app';
import I18n from './../i18n';

Vue.use(VueScrollTo);
Vue.directive('on-clickaway', onClickaway);

if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {
  Vue.config.productionTip = false;
}

$(document).ready(() => {
  new I18n();
  new Vue({
    el: '#vue_container',
    router,
    store,
    vueResource,
    render: h => h(App),
  });
});



// WEBPACK FOOTER //
// ./app/javascript/packs/auctions_catalogs/show.js